/* ============================================================================
   VEDIC CRYSTALS — Remedy Finder Widget JS
   ============================================================================
   Fixed: CSS block that broke the IIFE has been removed. CSS rules for
   .vrf-k-rasi-num / .vrf-k-planet / .vrf-k-lagna now belong in
   assets/tvc-remedy-finder.css — see the bottom of this file for the exact
   block to paste there.
   ============================================================================ */
(function () {
  'use strict';

  var WORKER_URL = window.VRF_WORKER_URL || 'https://late-grass-18d9.gauravbsharma.workers.dev/';
  var GEMSTONE_REPORT_URL = '/products/gemstone-recommendation-report';
  var CACHE_KEY_PREFIX = 'vrf_result_';
  var CACHE_TTL_MS = 24 * 60 * 60 * 1000;

  var PLANET_YANTRA_MANTRA = {
    Sun:     { yantra: 'Surya Yantra',   mantra: 'Om Hraam Hreem Hraum Sah Suryaya Namah',      count: '7,000 chants'  },
    Moon:    { yantra: 'Chandra Yantra', mantra: 'Om Shraam Shreem Shraum Sah Chandraya Namah', count: '11,000 chants' },
    Mars:    { yantra: 'Mangal Yantra',  mantra: 'Om Kraam Kreem Kraum Sah Bhaumaya Namah',     count: '10,000 chants' },
    Mercury: { yantra: 'Budh Yantra',    mantra: 'Om Braam Breem Braum Sah Budhaya Namah',      count: '9,000 chants'  },
    Jupiter: { yantra: 'Guru Yantra',    mantra: 'Om Graam Greem Graum Sah Gurave Namah',       count: '19,000 chants' },
    Venus:   { yantra: 'Shukra Yantra',  mantra: 'Om Draam Dreem Draum Sah Shukraya Namah',     count: '16,000 chants' },
    Saturn:  { yantra: 'Shani Yantra',   mantra: 'Om Praam Preem Praum Sah Shanaishcharaya Namah', count: '23,000 chants' },
    Rahu:    { yantra: 'Rahu Yantra',    mantra: 'Om Bhraam Bhreem Bhraum Sah Rahave Namah',    count: '18,000 chants' },
    Ketu:    { yantra: 'Ketu Yantra',    mantra: 'Om Sraam Sreem Sraum Sah Ketave Namah',       count: '17,000 chants' }
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return (root || document).querySelectorAll(sel); }

  function buildOptions(start, end, padTo) {
    var html = '<option value="">--</option>';
    for (var i = start; i <= end; i++) {
      var v = padTo ? String(i).padStart(padTo, '0') : i;
      html += '<option value="' + i + '">' + v + '</option>';
    }
    return html;
  }
  function todayISO() {
    var d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function buildMonthOptions() {
    var html = '<option value="">--</option>';
    for (var i = 0; i < 12; i++) html += '<option value="' + (i + 1) + '">' + MONTHS[i] + '</option>';
    return html;
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function tzOffset(hours) {
    var sign = hours >= 0 ? '+' : '-';
    var abs = Math.abs(hours);
    var h = Math.floor(abs);
    var m = Math.round((abs - h) * 60);
    return sign + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
  }

  function getTzOffsetForLocation(tzName, dateStr) {
    if (!tzName) return '+00:00';
    try {
      var d = new Date(dateStr || new Date());
      var local = new Date(d.toLocaleString('en-US', { timeZone: tzName }));
      var utc = new Date(d.toLocaleString('en-US', { timeZone: 'UTC' }));
      var diffH = (local - utc) / 3600000;
      return tzOffset(diffH);
    } catch (e) { return '+00:00'; }
  }

  function init(root) {
    if (!root || root.dataset.vrfInit) return;
    root.dataset.vrfInit = '1';
    root.innerHTML = renderEmpty(root);
    bindForm(root);
  }

  function renderEmpty(root) {
    var isHome = root && root.dataset.vrfContext === 'home';
    var headerParts = [];
    if (isHome) {
      headerParts.push(
        '<div class="vrf-card-header">',
          '<div class="vrf-free-tag">FREE</div>',
          '<h2 class="vrf-card-title-main">Find your <em>Vedic remedy</em></h2>',
          '<div class="vrf-meta-row">',
            '<span>Instant</span><span class="vrf-meta-sep">·</span>',
            '<span>No signup</span><span class="vrf-meta-sep">·</span>',
            '<span>Based on your chart</span>',
          '</div>',
        '</div>'
      );
    } else {
      headerParts.push(
        '<div class="vrf-eyebrow">Free Vedic Remedy Finder</div>',
        '<h1 class="vrf-headline">Find your <em>Vedic remedy</em><br>as per your birth chart</h1>',
        '<p class="vrf-subhead">Gemstone, Rudraksha, Yantra, Puja and Mantra, curated by our panel of <strong>124+ Vedic astrologers</strong>.</p>'
      );
    }
    return [
      '<div class="vrf-center">',
        headerParts.join(''),
        '<form class="vrf-form" novalidate>',
          '<div class="vrf-row">',
            '<div class="vrf-field">',
              '<label class="vrf-label" for="vrf-date">Date of birth</label>',
              '<input type="date" id="vrf-date" name="date" required min="1920-01-01" max="' + todayISO() + '" aria-describedby="vrf-date-help" />',
              '<div class="vrf-helper" id="vrf-date-help">Day, month and year.</div>',
            '</div>',
            '<div class="vrf-field">',
              '<label class="vrf-label" for="vrf-time">',
                '<span>Time of birth</span>',
                '<a href="' + GEMSTONE_REPORT_URL + '" class="vrf-label-help" data-vrf="no-time">Don\'t know?</a>',
              '</label>',
              '<input type="time" id="vrf-time" name="time" required aria-describedby="vrf-time-help" />',
              '<div class="vrf-helper" id="vrf-time-help">As close as you know it.</div>',
            '</div>',
          '</div>',
          '<div class="vrf-field vrf-city-wrap">',
            '<label class="vrf-label" for="vrf-city">Birth City</label>',
            '<input type="text" id="vrf-city" name="city" placeholder="Type any city worldwide" autocomplete="off" required />',
            '<div class="vrf-city-list" role="listbox"></div>',
            '<div class="vrf-helper">If your village isn\'t found, enter the nearest large city. Calculations remain accurate.</div>',
          '</div>',
          '<div class="vrf-form-error" role="alert" hidden></div>',
          '<div style="text-align:center;margin-top:14px">',
            '<button type="submit" class="vrf-cta">Find my remedy <span class="vrf-cta-arrow">→</span></button>',
          '</div>',
        '</form>',
        (isHome ? '' :
        '<div class="vrf-trust">' +
          '<span>✦ 19,000+ customers</span>' +
          '<span class="vrf-trust-dot">·</span>' +
          '<span>50+ countries</span>' +
          '<span class="vrf-trust-dot">·</span>' +
          '<span>Lab-certified gemstones</span>' +
        '</div>'),
        '<div class="vrf-palm-cta' + (isHome ? ' vrf-palm-hidden' : '') + '">',
          '<div class="vrf-palm-cta-icon" aria-hidden="true">✋</div>',
          '<div class="vrf-palm-cta-body">',
            '<div class="vrf-palm-cta-eyebrow">Don\'t know your birth time?</div>',
            '<h3 class="vrf-palm-cta-title">Try a <em>palm-based</em> reading instead</h3>',
            '<p class="vrf-palm-cta-desc">Our expert palmists can recommend your gemstone, rudraksha &amp; puja from photos of your palms, a 5,000-year-old <em>Samudrika Shastra</em> method, delivered as a full personalised report.</p>',
            '<a href="' + GEMSTONE_REPORT_URL + '" class="vrf-palm-cta-btn">Get Palm-Based Report →</a>',
          '</div>',
        '</div>',
        '<div class="vrf-foot">Calculated using classical Vedic Jyotish</div>',
      '</div>'
    ].join('');
  }

  function buildMinuteOptions() {
    var html = '<option value="">--</option>';
    for (var i = 0; i < 60; i++) html += '<option value="' + i + '">' + String(i).padStart(2, '0') + '</option>';
    return html;
  }
  function buildYearOptions() {
    var html = '<option value="">--</option>';
    var current = new Date().getFullYear();
    for (var y = current; y >= 1925; y--) html += '<option value="' + y + '">' + y + '</option>';
    return html;
  }

  function bindForm(root) {
    var form = $('.vrf-form', root);
    var cityInput = $('#vrf-city', root);
    var cityList = $('.vrf-city-list', root);
    var selectedCity = null;
    var fetchCities = debounce(function (q) {
      if (q.length < 2) { cityList.classList.remove('open'); return; }
      cityList.innerHTML = '<div class="vrf-city-loading">Searching…</div>';
      cityList.classList.add('open');
      fetch(WORKER_URL + '?action=geocode&q=' + encodeURIComponent(q))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var results = (data && data.results) || [];
          if (!results.length) {
            cityList.innerHTML = '<div class="vrf-city-empty">No matches. Try a nearby larger city.</div>';
            return;
          }
          cityList.innerHTML = results.map(function (r, i) {
            var sub = [r.admin, r.country].filter(Boolean).join(', ');
            return '<div class="vrf-city-item" data-i="' + i + '">' +
              escapeHtml(r.name) +
              (sub ? '<span class="vrf-city-item-sub">' + escapeHtml(sub) + '</span>' : '') +
              '</div>';
          }).join('');
          cityList._results = results;
        })
        .catch(function () { cityList.innerHTML = '<div class="vrf-city-empty">Search failed. Try again.</div>'; });
    }, 280);
    cityInput.addEventListener('input', function () { selectedCity = null; fetchCities(this.value.trim()); });
    cityInput.addEventListener('focus', function () { if (cityList.children.length) cityList.classList.add('open'); });
    cityList.addEventListener('click', function (e) {
      var item = e.target.closest('.vrf-city-item');
      if (!item || !cityList._results) return;
      var idx = +item.dataset.i;
      selectedCity = cityList._results[idx];
      var sub = [selectedCity.admin, selectedCity.country].filter(Boolean).join(', ');
      cityInput.value = selectedCity.name + (sub ? ', ' + sub : '');
      cityList.classList.remove('open');
    });
    document.addEventListener('click', function (e) {
      if (!cityInput.contains(e.target) && !cityList.contains(e.target)) cityList.classList.remove('open');
    });
    var noTimeLink = $('[data-vrf="no-time"]', root);
    var palmCta = $('.vrf-palm-cta', root);
    if (noTimeLink && palmCta && root.dataset.vrfContext === 'home') {
      noTimeLink.addEventListener('click', function (e) {
        e.preventDefault();
        palmCta.classList.remove('vrf-palm-hidden');
        try { palmCta.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) {}
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(root, form, selectedCity); });
  }

  function submit(root, form, selectedCity) {
    var dateEl = $('#vrf-date', root), timeEl = $('#vrf-time', root), cityEl = $('#vrf-city', root);
    var dv = dateEl ? dateEl.value : '', tv = timeEl ? timeEl.value : '';
    var dm = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dv);
    var year = dm ? +dm[1] : 0, month = dm ? +dm[2] : 0, day = dm ? +dm[3] : 0;
    var tm = /^(\d{2}):(\d{2})/.exec(tv);
    var h24 = tm ? +tm[1] : NaN, minute = tm ? +tm[2] : NaN;
    var parsed = dm ? new Date(Date.UTC(year, month - 1, day)) : null;
    var badDate = !(parsed && parsed.getUTCDate() === day && parsed.getUTCMonth() === month - 1 && parsed.getTime() <= Date.now());
    var badTime = !(tm && h24 >= 0 && h24 < 24 && minute >= 0 && minute < 60);
    var cityList = $('.vrf-city-list', root);
    if (!selectedCity && cityList && cityList._results && cityList._results.length && cityEl && cityEl.value.trim()) {
      selectedCity = cityList._results[0];
      cityEl.value = selectedCity.name + ([selectedCity.admin, selectedCity.country].filter(Boolean).length ? ', ' + [selectedCity.admin, selectedCity.country].filter(Boolean).join(', ') : '');
    }
    function flag(el, bad) {
      if (!el) return;
      var f = el.closest ? el.closest('.vrf-field') : null;
      if (f) f.classList.toggle('vrf-field--error', !!bad);
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
    }
    flag(dateEl, badDate); flag(timeEl, badTime); flag(cityEl, !selectedCity);
    var problems = [];
    if (badDate) problems.push('your date of birth');
    if (badTime) problems.push('your time of birth');
    if (!selectedCity) problems.push('your birth city (choose it from the list)');
    var errBox = $('.vrf-form-error', root);
    if (problems.length) {
      if (errBox) { errBox.textContent = 'Please add ' + problems.join(', ') + '.'; errBox.hidden = false; }
      var first = badDate ? dateEl : (badTime ? timeEl : cityEl);
      if (first) first.focus();
      return;
    }
    if (errBox) errBox.hidden = true;
    var dateStr = year + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    var timeStr = String(h24).padStart(2, '0') + ':' + String(minute).padStart(2, '0') + ':00';
    var tz = getTzOffsetForLocation(selectedCity.tz, dateStr + 'T' + timeStr);
    var datetime = dateStr + 'T' + timeStr + tz;
    var cacheKey = CACHE_KEY_PREFIX + hashStr(datetime + '|' + selectedCity.lat.toFixed(4) + '|' + selectedCity.lng.toFixed(4));
    try {
      var cached = localStorage.getItem(cacheKey);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed.t && (Date.now() - parsed.t) < CACHE_TTL_MS && parsed.r) {
          showResult(root, parsed.r);
          return;
        }
      }
    } catch (e) {}
    showLoading(root);
    fetch(WORKER_URL + '?action=remedy&datetime=' + encodeURIComponent(datetime) + '&lat=' + selectedCity.lat + '&lng=' + selectedCity.lng)
      .then(function (r) { return r.json().then(function (data) { return { status: r.status, data: data }; }); })
      .then(function (resp) {
        if (resp.status === 429) { showError(root, resp.data.message || 'Rate limit reached. Try later.', resp.data.contact); return; }
        if (resp.status !== 200 || resp.data.error) { showError(root, resp.data.message || resp.data.error || 'Something went wrong. Please try again.'); return; }
        try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), r: resp.data })); } catch (e) {}
        showResult(root, resp.data);
      })
      .catch(function (err) { showError(root, 'Network error: ' + err.message); });
  }

  function hashStr(s) {
    var h = 0;
    for (var i = 0; i < s.length; i++) { h = ((h << 5) - h) + s.charCodeAt(i); h |= 0; }
    return Math.abs(h).toString(36);
  }

  function showLoading(root) {
    root.innerHTML = '<div class="vrf-loading"><div class="vrf-spinner"></div><div>Reading your chart…</div></div>';
  }

  function showError(root, msg, contactUrl) {
    var contactLine = contactUrl ? '<div style="margin-top:8px"><a href="' + contactUrl + '" style="color:#A8893E">Contact us for API access →</a></div>' : '';
    var errHtml = '<div class="vrf-error">' + escapeHtml(msg) + contactLine + '</div>' +
      '<div style="text-align:center;margin-top:12px"><button class="vrf-cta" data-vrf="retry">Try Again</button></div>';
    root.innerHTML = errHtml;
    var retry = $('[data-vrf="retry"]', root);
    if (retry) retry.addEventListener('click', function () { root.dataset.vrfInit = ''; init(root); });
  }

  function showResult(root, r) {
    root.innerHTML = buildResultHtml(r);
    bindResult(root, r);
    var resetBtn = $('[data-vrf="reset"]', root);
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        root.dataset.vrfInit = '';
        init(root);
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      });
    }
    try { history.replaceState(null, '', '#lagna-' + r.lagna.toLowerCase()); } catch (e) {}
    injectProductSchema(r);
  }

  function buildKundliSvg(kundli) {
    if (!kundli || !kundli.byHouse) return '';

    // Rasi (sign) → number (1=Aries ... 12=Pisces)
    var RASI_INDEX = {
      Aries: 1, Taurus: 2, Gemini: 3, Cancer: 4, Leo: 5, Virgo: 6,
      Libra: 7, Scorpio: 8, Sagittarius: 9, Capricorn: 10, Aquarius: 11, Pisces: 12
    };
    var lagnaRasiNum = RASI_INDEX[kundli.lagnaRasi] || 1;

    // House center coordinates in the classic North Indian layout
    var centers = {
      1: [140, 60],   2: [62, 30],    3: [30, 62],    4: [62, 140],
      5: [30, 218],   6: [62, 250],   7: [140, 220],  8: [218, 250],
      9: [250, 218], 10: [218, 140], 11: [250, 62],  12: [218, 30]
    };

    var parts = [
      '<rect x="2" y="2" width="276" height="276" fill="none" stroke="currentColor" stroke-width="1.5"/>',
      '<line x1="2" y1="2" x2="278" y2="278" stroke="currentColor" stroke-width="1.5"/>',
      '<line x1="278" y1="2" x2="2" y2="278" stroke="currentColor" stroke-width="1.5"/>',
      '<polygon points="140,2 278,140 140,278 2,140" fill="none" stroke="currentColor" stroke-width="1.5"/>'
    ];

    for (var i = 1; i <= 12; i++) {
      var c = centers[i];
      var hp = kundli.byHouse[i] || [];
      // Rasi number in this house = (lagna_rasi + house - 1) mod 12 (as 1-12)
      var rasiNum = ((lagnaRasiNum - 1 + i - 1) % 12) + 1;

      // Rasi number — small, positioned above the house center
      parts.push('<text x="' + c[0] + '" y="' + (c[1] - 10) + '" class="vrf-k-rasi-num" text-anchor="middle">' + rasiNum + '</text>');

      // Planet abbreviations — centered
      if (hp.length) {
        var codes = hp.map(function (p) { return p.code + (p.retrograde ? '(R)' : ''); }).join(' ');
        parts.push('<text x="' + c[0] + '" y="' + (c[1] + 8) + '" class="vrf-k-planet" text-anchor="middle">' + codes + '</text>');
      }

      // "La" (Lagna) marker for house 1
      if (i === 1) {
        parts.push('<text x="' + c[0] + '" y="' + (c[1] + 24) + '" class="vrf-k-lagna" text-anchor="middle">La</text>');
      }
    }

    return '<svg viewBox="0 0 280 280" class="vrf-kundli-svg" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Your Vedic kundli (birth chart)">' + parts.join('') + '</svg>';
  }

  function buildPlanetTable(kundli) {
    if (!kundli || !kundli.planets || !kundli.planets.length) return '';
    var rows = kundli.planets.map(function (p) {
      var deg = (typeof p.longitude === 'number') ? (((p.longitude % 30) + 30) % 30).toFixed(1) + '°' : '—';
      var status = p.retrograde ? '<span class="vrf-k-retro">Retrograde</span>' : '<span class="vrf-k-direct">Direct</span>';
      return '<tr><td class="vrf-k-pname"><strong>' + escapeHtml(p.name) + '</strong> <span class="vrf-k-pcode">' + escapeHtml(p.code) + '</span></td>'
        + '<td>' + escapeHtml(p.rasi || '—') + '</td>'
        + '<td class="vrf-k-deg">' + deg + '</td>'
        + '<td>' + status + '</td></tr>';
    }).join('');
    var lagnaDeg = (typeof kundli.lagnaLongitude === 'number') ? (((kundli.lagnaLongitude % 30) + 30) % 30).toFixed(1) + '°' : '—';
    var lagnaRow = '<tr class="vrf-k-lagna-row"><td class="vrf-k-pname"><strong>Ascendant</strong> <span class="vrf-k-pcode">La</span></td>'
      + '<td>' + escapeHtml(kundli.lagnaRasi || '—') + '</td>'
      + '<td class="vrf-k-deg">' + lagnaDeg + '</td><td>—</td></tr>';
    return '<div class="vrf-k-table-wrap"><div class="vrf-k-table-title">Planetary Positions</div>'
      + '<table class="vrf-k-table"><thead><tr><th>Planet</th><th>Sign</th><th>Degree</th><th>Motion</th></tr></thead>'
      + '<tbody>' + lagnaRow + rows + '</tbody></table></div>';
  }

  function buildResultHtml(r) {
    var primaryGemName = r.gemstone.name.split(' (')[0];
    var ym = PLANET_YANTRA_MANTRA[r.lord] || { yantra: 'Navgraha Yantra', mantra: 'Om Namah Shivaya', count: '108 chants' };

    var subHtml = '<strong>Affordable alternative:</strong> ' +
      '<a href="' + r.gemstone.substitute.url + '">' + escapeHtml(r.gemstone.substitute.name) + '</a>';
    if (r.gemstone.substitute.alt) {
      subHtml += ' <span style="opacity:0.7">or</span> ' +
        '<a href="' + r.gemstone.substitute.alt.url + '">' + escapeHtml(r.gemstone.substitute.alt.name) + '</a>';
    }
    var snapshotHtml = '';
    if (r.birthChart && (r.birthChart.sunSign || r.birthChart.moonSign || r.birthChart.nakshatra)) {
      var bc = r.birthChart;
      var sunItem = bc.sunSign ? '<div class="vrf-snap-item"><div class="vrf-snap-icon" aria-hidden="true">☉</div><div class="vrf-snap-label">Sun Sign</div><div class="vrf-snap-value">' + escapeHtml(bc.sunSign) + (bc.sunSignSanskrit && bc.sunSignSanskrit.toLowerCase() !== bc.sunSign.toLowerCase() ? ' <span class="vrf-snap-sub">(' + escapeHtml(bc.sunSignSanskrit) + ')</span>' : '') + '</div></div>' : '';
      var moonItem = bc.moonSign ? '<div class="vrf-snap-item"><div class="vrf-snap-icon" aria-hidden="true">☽</div><div class="vrf-snap-label">Moon Sign</div><div class="vrf-snap-value">' + escapeHtml(bc.moonSign) + (bc.moonSignSanskrit && bc.moonSignSanskrit.toLowerCase() !== bc.moonSign.toLowerCase() ? ' <span class="vrf-snap-sub">(' + escapeHtml(bc.moonSignSanskrit) + ')</span>' : '') + '</div></div>' : '';
      var nakItem = bc.nakshatra ? '<div class="vrf-snap-item"><div class="vrf-snap-icon" aria-hidden="true">✦</div><div class="vrf-snap-label">Nakshatra</div><div class="vrf-snap-value">' + escapeHtml(bc.nakshatra) + (bc.pada ? ' <span class="vrf-snap-sub">Pada ' + escapeHtml(String(bc.pada)) + '</span>' : '') + '</div></div>' : '';
      if (sunItem || moonItem || nakItem) {
        snapshotHtml = '<div class="vrf-snapshot"><div class="vrf-snap-eyebrow">Your Chart</div><div class="vrf-snap-grid">' + sunItem + moonItem + nakItem + '</div></div>';
      }
    }
    var doshasHtml = '';
    var pujaUrl = r.doshaPujaUrl || '/collections/navgrah-pooja-navagraha-graha-shanti';
    var doshaParts = [];
    if (r.manglik) {
      if (r.manglik.has) {
        doshaParts.push('<div class="vrf-dosha-card vrf-dosha-active"><div class="vrf-dosha-icon" aria-hidden="true">⚠</div><div class="vrf-dosha-body"><div class="vrf-dosha-title">Mangal Dosha Present</div><div class="vrf-dosha-desc">Mars (Mangal) is afflicting key houses in your chart, traditionally associated with friction in marriage, partnerships, and impulsive decisions. A targeted Mangal Pooja is the classical Vedic remedy.</div><a href="' + pujaUrl + '" class="vrf-dosha-link">Pacify with Mangal Pooja →</a></div></div>');
      } else {
        doshaParts.push('<div class="vrf-dosha-clear"><span class="vrf-dosha-check" aria-hidden="true">✓</span> <strong>No Mangal Dosha.</strong> Mars sits favourably for you.</div>');
      }
    }
    if (r.kaalSarp) {
      if (r.kaalSarp.has) {
        var ksTypeLabel = r.kaalSarp.type ? ' (' + escapeHtml(r.kaalSarp.type) + ')' : '';
        doshaParts.push('<div class="vrf-dosha-card vrf-dosha-active"><div class="vrf-dosha-icon" aria-hidden="true">⚠</div><div class="vrf-dosha-body"><div class="vrf-dosha-title">Kaal Sarp Dosha Present' + ksTypeLabel + '</div><div class="vrf-dosha-desc">All seven planets are positioned between Rahu and Ketu in your chart. This shadow-planet alignment can manifest as sudden setbacks, delayed success, and recurring obstacles. The classical remedy is a Rahu-Ketu Shanti Pooja.</div><a href="' + pujaUrl + '" class="vrf-dosha-link">Pacify with Rahu-Ketu Pooja →</a></div></div>');
      } else {
        doshaParts.push('<div class="vrf-dosha-clear"><span class="vrf-dosha-check" aria-hidden="true">✓</span> <strong>No Kaal Sarp Dosha.</strong> Rahu and Ketu do not enclose your planets.</div>');
      }
    }
    if (r.sadeSati) {
      if (r.sadeSati.active) {
        var phaseLabel = r.sadeSati.phase ? ' — ' + escapeHtml(r.sadeSati.phase) + ' phase' : '';
        doshaParts.push('<div class="vrf-dosha-card vrf-dosha-active"><div class="vrf-dosha-icon" aria-hidden="true">⚠</div><div class="vrf-dosha-body"><div class="vrf-dosha-title">Sade Sati Active' + phaseLabel + '</div><div class="vrf-dosha-desc">Saturn (Shani) is transiting the 12th, 1st, or 2nd house from your Moon: the 7.5-year period traditionally associated with karmic restructuring, delays, and tests of endurance. A Shani Shanti Pooja reduces its harshness.</div><a href="' + pujaUrl + '" class="vrf-dosha-link">Pacify with Shani Pooja →</a></div></div>');
      } else {
        doshaParts.push('<div class="vrf-dosha-clear"><span class="vrf-dosha-check" aria-hidden="true">✓</span> <strong>Not in Sade Sati.</strong> Saturn is not currently afflicting your Moon.</div>');
      }
    }
    if (doshaParts.length) {
      doshasHtml = '<div class="vrf-doshas"><div class="vrf-doshas-eyebrow">Important Insights From Your Chart</div>' + doshaParts.join('') + '</div>';
    }

    // Yogas (planetary combinations) — favorable + unfavorable
    var yogasHtml = '';
    if (r.yogas && (r.yogas.favorable && r.yogas.favorable.length) || (r.yogas && r.yogas.unfavorable && r.yogas.unfavorable.length)) {
      var yogaParts = [];
      (r.yogas.favorable || []).forEach(function (y) {
        yogaParts.push(
          '<div class="vrf-yoga-card vrf-yoga-favorable">' +
            '<div class="vrf-yoga-icon" aria-hidden="true">★</div>' +
            '<div class="vrf-yoga-body">' +
              '<div class="vrf-yoga-title">' + escapeHtml(y.name) + '</div>' +
              '<div class="vrf-yoga-desc">' + escapeHtml(y.description) + '</div>' +
            '</div>' +
          '</div>'
        );
      });
      (r.yogas.unfavorable || []).forEach(function (y) {
        yogaParts.push(
          '<div class="vrf-yoga-card vrf-yoga-unfavorable">' +
            '<div class="vrf-yoga-icon" aria-hidden="true">⚠</div>' +
            '<div class="vrf-yoga-body">' +
              '<div class="vrf-yoga-title">' + escapeHtml(y.name) + '</div>' +
              '<div class="vrf-yoga-desc">' + escapeHtml(y.description) + '</div>' +
            '</div>' +
          '</div>'
        );
      });
      if (yogaParts.length) {
        yogasHtml = '<div class="vrf-yogas"><div class="vrf-yogas-eyebrow">Yogas In Your Chart</div>' + yogaParts.join('') + '</div>';
      }
    }

    return [
      '<div class="vrf-result-header">',
        '<div class="vrf-result-eyebrow">Based on your chart</div>',
        '<h2 class="vrf-result-title">Your primary remedy<br>is <em>' + escapeHtml(primaryGemName) + '</em></h2>',
        '<div class="vrf-result-lord">' + escapeHtml(r.lagna) + ' (' + escapeHtml(r.lagnaSanskrit) + ') ascendant · ruled by <strong>' + escapeHtml(r.lord) + '</strong></div>',
      '</div>',
      snapshotHtml,
      r.kundli && r.kundli.byHouse
        ? ('<details open class="vrf-kundli-details"><summary class="vrf-kundli-summary"><span class="vrf-kundli-eyebrow">Your Kundli chart</span><span class="vrf-kundli-toggle">↓</span></summary><div class="vrf-kundli-body">' + buildKundliSvg(r.kundli) + buildPlanetTable(r.kundli) + '<div class="vrf-kundli-legend"><strong>Su</strong> Sun · <strong>Mo</strong> Moon · <strong>Ma</strong> Mars · <strong>Me</strong> Mercury · <strong>Ju</strong> Jupiter · <strong>Ve</strong> Venus · <strong>Sa</strong> Saturn · <strong>Ra</strong> Rahu · <strong>Ke</strong> Ketu · <strong>La</strong> Lagna · <strong>(R)</strong> Retrograde</div></div></details>')
        : '',
      '<div class="vrf-remedies-eyebrow">Your recommended remedies</div>',
      '<div class="vrf-cards">',
        '<div class="vrf-card vrf-card-primary"><span class="vrf-card-badge">PRIMARY</span><div class="vrf-card-icon gem">◈</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Gemstone</div><h3 class="vrf-card-title">' + escapeHtml(r.gemstone.name) + ' <em>(' + escapeHtml(r.gemstone.sanskrit) + ')</em></h3><p class="vrf-card-desc">' + escapeHtml(r.gemstone.description) + '</p><div class="vrf-card-sub">' + subHtml + '</div><a href="' + r.gemstone.url + '" class="vrf-card-link">Shop ' + escapeHtml(r.gemstone.name) + ' →</a></div></div>',
        '<div class="vrf-card"><div class="vrf-card-icon rud">' + escapeHtml(getRudNum(r.rudraksha.name)) + '</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Rudraksha</div><h3 class="vrf-card-title">' + escapeHtml(r.rudraksha.name) + '</h3><p class="vrf-card-desc">' + escapeHtml(r.rudraksha.description) + '</p><a href="' + r.rudraksha.url + '" class="vrf-card-link">Shop Rudraksha →</a></div></div>',
        '<div class="vrf-card"><div class="vrf-card-icon yan">◇</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Yantra</div><h3 class="vrf-card-title">' + escapeHtml(ym.yantra) + '</h3><p class="vrf-card-desc">A sacred geometric diagram that amplifies planetary energy. Placed at home or worn on the person to reinforce the remedy.</p><a href="/collections/yantra-vedic-yantra" class="vrf-card-link">Shop Yantras →</a></div></div>',
        '<div class="vrf-card"><div class="vrf-card-icon puja">🪔</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Puja</div><h3 class="vrf-card-title">' + escapeHtml(r.puja.name) + '</h3><p class="vrf-card-desc">' + escapeHtml(r.puja.description) + '</p><a href="' + r.puja.url + '" class="vrf-card-link">Book Puja →</a></div></div>',
        '<div class="vrf-card vrf-card-mantra"><div class="vrf-card-icon mantra">🕉</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Mantra · ' + escapeHtml(ym.count) + '</div><h3 class="vrf-card-title vrf-mantra-text">' + escapeHtml(ym.mantra) + '</h3><p class="vrf-card-desc">Chant daily at sunrise for maximum effect. Traditionally chanted with a Rudraksha mala.</p></div></div>',
      '</div>',
      yogasHtml,
      doshasHtml,
      '<div class="vrf-email" data-vrf="email">',
        '<span class="vrf-email-icon">✉</span>',
        '<span class="vrf-email-label">Email me my Vedic remedy</span>',
        '<form class="vrf-email-form" data-vrf-result=\'' + escapeAttr(JSON.stringify({ lagna: r.lagna, gem: r.gemstone.name, rud: r.rudraksha.name, puja: r.puja.name })) + '\'>',
          '<input type="email" placeholder="your@email.com" required />',
          '<button type="submit">Send</button>',
        '</form>',
      '</div>',
      '<div class="vrf-upsell">',
        '<h3>Want the <em>full picture</em>?</h3>',
        '<p>A complete report analyses your dashas, planetary positions, doshas, and yogas, and gives you a precise action plan from our 124+ astrologer panel.</p>',
        '<div class="vrf-upsell-actions">',
          '<a href="' + GEMSTONE_REPORT_URL + '" class="vrf-btn-primary">Get Full Personalised Report</a>',
          '<a href="' + r.gemstone.url + '" class="vrf-btn-secondary">Shop Your ' + escapeHtml(r.gemstone.name) + '</a>',
        '</div>',
      '</div>',
      '<div class="vrf-reset-row">',
        '<button type="button" class="vrf-reset-btn" data-vrf="reset">← Check another chart</button>',
      '</div>'
    ].join('');
  }

  function getRudNum(name) {
    var m = (name || '').match(/^(\d+)/);
    return m ? m[1] : '◊';
  }

  function bindResult(root, r) {
    var emailForm = $('.vrf-email-form', root);
    if (!emailForm) return;
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = emailForm.querySelector('input[type=email]');
      var submitBtn = emailForm.querySelector('button');
      var email = emailInput.value.trim();
      if (!email) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
      var lines = [
        'Vedic Remedy Finder: Personalised Report', '',
        '━━━ Your Details ━━━',
        'Email:           ' + email, '',
        '━━━ Your Vedic Birth Chart ━━━',
        'Ascendant (Lagna): ' + r.lagna + ' (' + r.lagnaSanskrit + ')',
        'Ruling Planet:     ' + r.lord + ' (' + r.lordSanskrit + ')'
      ];
      if (r.birthChart) {
        if (r.birthChart.sunSign)   lines.push('Sun Sign:          ' + r.birthChart.sunSign + (r.birthChart.sunSignSanskrit && r.birthChart.sunSignSanskrit !== r.birthChart.sunSign ? ' (' + r.birthChart.sunSignSanskrit + ')' : ''));
        if (r.birthChart.moonSign)  lines.push('Moon Sign (Rashi): ' + r.birthChart.moonSign + (r.birthChart.moonSignSanskrit && r.birthChart.moonSignSanskrit !== r.birthChart.moonSign ? ' (' + r.birthChart.moonSignSanskrit + ')' : ''));
        if (r.birthChart.nakshatra) lines.push('Nakshatra:         ' + r.birthChart.nakshatra + (r.birthChart.pada ? ', Pada ' + r.birthChart.pada : ''));
      }
      lines.push('');
      lines.push('━━━ Your Recommended Remedies ━━━');
      lines.push('Gemstone:  ' + r.gemstone.name + ' (' + r.gemstone.sanskrit + ')');
      lines.push('           Substitute: ' + r.gemstone.substitute.name);
      lines.push('Rudraksha: ' + r.rudraksha.name);
      var ymE = PLANET_YANTRA_MANTRA[r.lord] || {};
      if (ymE.yantra) lines.push('Yantra:    ' + ymE.yantra);
      lines.push('Puja:      ' + r.puja.name);
      if (ymE.mantra) lines.push('Mantra:    ' + ymE.mantra + ' (' + ymE.count + ')');
      if (r.yogas && ((r.yogas.favorable && r.yogas.favorable.length) || (r.yogas.unfavorable && r.yogas.unfavorable.length))) {
        lines.push('');
        lines.push('━━━ Yogas In Your Chart ━━━');
        (r.yogas.favorable || []).forEach(function (y) { lines.push('★ ' + y.name + ' (favorable) — ' + y.description); });
        (r.yogas.unfavorable || []).forEach(function (y) { lines.push('⚠ ' + y.name + ' (unfavorable) — ' + y.description); });
      }
      lines.push('');
      lines.push('━━━ Dosha & Transit Analysis ━━━');
      if (r.manglik)  lines.push('Mangal Dosha:    ' + (r.manglik.has  ? 'PRESENT — recommend Mangal Pooja' : 'Not present'));
      if (r.kaalSarp) lines.push('Kaal Sarp Dosha: ' + (r.kaalSarp.has ? ('PRESENT' + (r.kaalSarp.type ? ' (' + r.kaalSarp.type + ')' : '') + ' — recommend Rahu-Ketu Pooja') : 'Not present'));
      if (r.sadeSati) lines.push('Sade Sati:       ' + (r.sadeSati.active ? ('ACTIVE' + (r.sadeSati.phase ? ' (' + r.sadeSati.phase + ' phase)' : '') + ' — recommend Shani Pooja') : 'Not currently active'));
      lines.push('');
      lines.push('━━━ Source ━━━');
      lines.push('Page: ' + window.location.href);
      lines.push('Generated: ' + new Date().toISOString());
      var body = lines.join('\n');
      var csrf = document.querySelector('input[name="authenticity_token"]') || document.querySelector('meta[name="csrf-token"]');
      var token = csrf ? (csrf.value || csrf.content) : '';
      var formBody = 'contact[name]=' + encodeURIComponent('VRF — ' + r.lagna) +
        '&contact[email]=' + encodeURIComponent(email) +
        '&contact[body]=' + encodeURIComponent(body) +
        '&form_type=contact&utf8=%E2%9C%93';
      if (token) formBody += '&authenticity_token=' + encodeURIComponent(token);
      fetch('/contact#contact_form', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: formBody }).catch(function () {});
      try {
        var f = document.createElement('form');
        f.method = 'POST'; f.action = '/contact#contact_form'; f.style.display = 'none';
        f.target = 'vrf_email_frame';
        var fields = { 'contact[name]': 'VRF — ' + r.lagna, 'contact[email]': email, 'contact[body]': body, 'form_type': 'contact', 'utf8': '✓' };
        if (token) fields.authenticity_token = token;
        Object.keys(fields).forEach(function (k) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = k; i.value = fields[k];
          f.appendChild(i);
        });
        var ifr = document.createElement('iframe');
        ifr.name = 'vrf_email_frame'; ifr.style.display = 'none';
        document.body.appendChild(ifr); document.body.appendChild(f); f.submit();
        setTimeout(function () { f.remove(); ifr.remove(); }, 5000);
      } catch (e) {}
      setTimeout(function () {
        emailForm.parentNode.innerHTML = '<div class="vrf-email-sent">✓ Sent. Your Vedic remedy is on its way to your inbox.</div>';
      }, 500);
    });
  }

  function injectProductSchema(r) {
    var old = document.getElementById('vrf-product-schema');
    if (old) old.remove();
    var schema = {
      '@context': 'https://schema.org', '@type': 'Product',
      'name': r.gemstone.name + ' (' + r.gemstone.sanskrit + ')',
      'description': r.gemstone.description + ' Recommended for ' + r.lagna + ' (' + r.lagnaSanskrit + ') ascendants.',
      'url': window.location.origin + r.gemstone.url,
      'brand': { '@type': 'Brand', 'name': 'Vedic Crystals' },
      'category': 'Vedic Astrological Gemstones'
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json'; s.id = 'vrf-product-schema';
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return String(s || '').replace(/'/g, '&#39;').replace(/"/g, '&quot;'); }

  function start() {
    $$('.vrf').forEach(function (root) {
      if (root.closest('article') || root.closest('.article-template')) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { init(entry.target); io.unobserve(entry.target); }
            });
          }, { rootMargin: '200px' });
          io.observe(root);
        } else { init(root); }
      } else { init(root); }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();

/* ============================================================================
   PASTE THIS INTO assets/tvc-remedy-finder.css (NOT in this JS file!)
   ============================================================================

.vrf-k-rasi-num {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 13px;
  font-weight: 600;
  fill: #A8893E;
  letter-spacing: 0.5px;
}
.vrf-k-planet {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 11px;
  fill: #1B1F3B;
  font-weight: 600;
}
.vrf-k-lagna {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 10px;
  font-weight: 700;
  fill: #C41E3A;
  letter-spacing: 1px;
}

   ============================================================================ */